import { render, staticRenderFns } from "./SettingMessageTemplateForm.vue?vue&type=template&id=9cb7f16c"
import script from "./SettingMessageTemplateForm.vue?vue&type=script&lang=js"
export * from "./SettingMessageTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports